import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiEndPoints } from '../../../common/api.endPoints';
import { TaskState } from '../../../common/constants/states';
import { HttpService } from '../../../common/http.service';
import { QuickFilters } from '../../../common/interfaces/quickFilters/QuickFilters';

export const fetchTaskCounts = createAsyncThunk(
  'metadata/fetchDeclineConditions',
  async (filters: QuickFilters) => {
    let taskType: string[] = [];
    try {
      // Get list of task types from the filters
      const s = new Set<string>();
      filters.section.forEach(({ list }) =>
        list?.forEach(({ queryBody }) =>
          queryBody?.taskType?.forEach((type: any) => {
            if (type) {
              s.add(type);
            }
          }),
        ),
      );
      taskType = [...s.values()];
    } catch (e) {
      console.error('Failed getting task types for task counts', e);
    }

    if (!taskType?.length) {
      return { count: {} };
    }
    const response = await HttpService.getInstance().post(
      apiEndPoints.taskCounts,
      { taskState: [TaskState.REQUESTED, TaskState.ORDERED], taskType },
    );

    if (response && !response.error) {
      // Translate from response format to internal double nested map.
      const count = response.parsedBody.taskCounts.reduce(
        (
          acc: any,
          o: { count: number; taskState: string; taskType: string },
        ) => {
          acc[
            o.taskState === TaskState.REQUESTED
              ? TaskState.REQUESTED
              : TaskState.ORDERED
          ][o.taskType] = o.count;
          return acc;
        },
        {
          [TaskState.REQUESTED]: {},
          [TaskState.ORDERED]: {},
        },
      );
      return { count };
    }

    return { count: {} };
  },
);

export const dashboardV2Slice = createSlice({
  name: 'dashboardV2',

  initialState: {
    taskCounts: {
      loading: false,
      count: {} as {
        [taskState: string]: {
          [taskType: string]: number;
        };
      },
    },
  },

  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchTaskCounts.pending, state => {
      state.taskCounts.loading = true;
    });
    builder.addCase(fetchTaskCounts.fulfilled, (state, action) => {
      state.taskCounts.count = action.payload.count;
      state.taskCounts.loading = false;
    });
    builder.addCase(fetchTaskCounts.rejected, state => {
      state.taskCounts.loading = false;
    });
  },
});

export const dashboardV2Reducer = dashboardV2Slice.reducer;
export const dashboardV2Actions = dashboardV2Slice.actions;
